<template>
  <div class="actions hidden-xs">
    <BaseIconDropdown v-slot="{ turnOff }">
      <ul class="dropdown-menu dropdown-menu-right" style="display: block; position: relative">
        <li>
          <a class="pointer" @click="fZip(toggleEdit(), turnOff())">
            {{
              $store.state.edit.saving
                ? $t('Saving...')
                : $store.state.edit.on
                ? $t("I'm done editing")
                : $t('Edit profile')
            }}
          </a>
        </li>
        <li>
          <a href="/profile/edit">{{ $t('Edit account settings') }}</a>
        </li>
      </ul>
    </BaseIconDropdown>
  </div>
</template>

<script>
import { SET_EDIT_STATE } from '@/state/mutation-types'
import BaseIconDropdown from '@/components/BaseIconDropdown.vue'
import MethodFZipMixin from '@/mixins/MethodFZipMixin'

export default {
  name: 'PageProfileMenuDropdownEdit',
  components: {
    BaseIconDropdown,
  },
  mixins: [MethodFZipMixin],
  methods: {
    toggleEdit() {
      this.$store.commit(SET_EDIT_STATE, !this.$store.state.edit.on)
    },
  },
}
</script>

<style scoped lang="scss"></style>
